export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8554.4d2ac34a.jpg";